import React, { useState, useRef, useEffect } from 'react';
import { IoChevronDown } from 'react-icons/io5';
import PropTypes from 'prop-types';
import './styles.scss';
import { useTranslation } from 'react-i18next';

const BulkActionsDropdown = ({
  resetEnabled,
  onActionSelect,
  disabled,
  ...props
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const actions = [
    { id: 'reset', label: t('Reset devices'), disabled: !resetEnabled },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleActionClick = (actionId) => {
    onActionSelect(actionId);
    setIsOpen(false);
  };

  return (
    <div className="BulkActionsDropdown" ref={dropdownRef} {...props}>
      <button
        className={`BulkActionsDropdown-trigger ${
          disabled ? 'is-disabled' : ''
        }`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        type="button"
      >
        <span>{t('Bulk Actions')}</span>
        <IoChevronDown className="BulkActionsDropdown-chevron" />
      </button>

      {isOpen && (
        <div className="BulkActionsDropdown-menu">
          <div className="BulkActionsDropdown-menuContent" role="menu">
            {actions.map((action) => (
              <button
                disabled={action.disabled}
                key={action.id}
                className={`BulkActionsDropdown-menuItem ${
                  action.disabled ? 'disabled' : ''
                }`}
                onClick={() => handleActionClick(action.id)}
                role="menuitem"
                type="button"
              >
                {action.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

BulkActionsDropdown.propTypes = {
  onActionSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  resetEnabled: PropTypes.bool,
};

BulkActionsDropdown.defaultProps = {
  disabled: false,
  resetEnabled: false,
};

export default BulkActionsDropdown;
